<template>
  <div class="match-invite-page">
    <Breadcrumb :type="1"></Breadcrumb>
    <div class="project-contain">
      <div class="tab-row" ref="historyList">
        <div
          class="tab-flex"
          v-for="(item, index) in tabList"
          :key="index"
          @click="onTab(item)"
        >
          <div
            class="item"
            :class="categoryId == item.categoryCode ? 'item-active' : ''"
          >
            {{ item.categoryName }}
          </div>
          <div class="hr" v-if="categoryId == item.categoryCode"></div>
        </div>
      </div>
      <div class="project-list">
        <div
          class="project-item"
          v-for="(item, index) in newsList"
          :key="index"
          @click="onDetail(item)"
        >
          <div class="project-item-img">
            <img :src="item.cover" alt="" class="image" />
          </div>
          <div class="footer-row">
            <div class="name">{{ item.articleName }}</div>
            <div class="read-more">
              <div class="text">查看</div>
              <img
                src="@/assets/images/you.png"
                alt="箭头"
                class="arrow-icon"
              />
            </div>
          </div>
        </div>
      </div>
      <Pagination
        :pageSize="pageSize"
        :pageCount="pageCount"
        @changePageClick="changePageClick"
        v-if="newsList.length > 0"
      ></Pagination>
      <el-empty description="暂无数据" v-if="newsList.length == 0"></el-empty>
    </div>
  </div>
</template>
<script>
import { getNavItemByCode } from '@/api/common/common.js'
import { getArticlePage } from '@/api/home/home.js'
import Breadcrumb from '@/components/common/breadcrumb'
import Pagination from '@/components/common/Pagination.vue'
export default {
  components: {
    Breadcrumb,
    Pagination
  },
  data() {
    return {
      categoryId: '',
      tabcode: '',
      tabList: [],
      tabIndex: '', // 选中的
      pageSize: 6, //分页数量
      pageCount: 0, //列表总数
      newsList: [],
      isDown: false,
      startX: 0,
      scrollLeft: 0
    }
  },
  created() {
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.fetchData()
  },
  mounted() {
    const el = this.$refs.historyList
    el.addEventListener('mousedown', this.onMouseDown)
    el.addEventListener('mouseleave', this.onMouseLeave)
    el.addEventListener('mouseup', this.onMouseUp)
    el.addEventListener('mousemove', this.onMouseMove)
  },
  beforeDestroy() {
    const el = this.$refs.historyList
    el.removeEventListener('mousedown', this.onMouseDown)
    el.removeEventListener('mouseleave', this.onMouseLeave)
    el.removeEventListener('mouseup', this.onMouseUp)
    el.removeEventListener('mousemove', this.onMouseMove)
  },
  methods: {
    // 获取项目分类
    fetchData() {
      getNavItemByCode(this.categoryId).then((res) => {
        this.tabList = res.data[0]?.list
        if (this.tabList.length != 0) {
          this.categoryId = this.tabList[0].categoryCode
          this.getArticlePage()
        }
      })
    },
    //获取文章列表
    getArticlePage(page = 1) {
      getArticlePage({
        page: page,
        limit: this.pageSize,
        categoryCode: this.categoryId
      }).then((res) => {
        if (!res.data) return
        this.newsList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page)
    },
    onTab(row) {
      this.categoryId = row.categoryCode
      this.getArticlePage()
    },
    //   跳转详情
    onDetail(row) {
      if (row.articleUrl) {
        window.open(row.articleUrl)
      } else {
        this.$router.push({
          path: '/base/project/detail',
          query: {
            id: row.articleId,
            tabcode: this.tabcode,
            categoryId: this.$route.query?.categoryId
          }
        })
      }
    },
    onMouseDown(e) {
      this.isDown = true
      this.startX = e.pageX - this.$refs.historyList.offsetLeft
      this.scrollLeft = this.$refs.historyList.scrollLeft
      this.$refs.historyList.style.cursor = 'grabbing'
    },
    onMouseLeave() {
      this.isDown = false
      this.$refs.historyList.style.cursor = 'grab'
    },
    onMouseUp() {
      this.isDown = false
      this.$refs.historyList.style.cursor = 'grab'
    },
    onMouseMove(e) {
      if (!this.isDown) return
      e.preventDefault()
      const x = e.pageX - this.$refs.historyList.offsetLeft
      const walk = (x - this.startX) * 1 // 滑动速度
      this.$refs.historyList.scrollLeft = this.scrollLeft - walk
    }
  }
}
</script>

<style scoped lang="scss">
.match-invite-page {
  display: flex;
  flex-direction: column;
  .project-contain {
    display: flex;
    flex-direction: column;
    width: 1472px;
    margin: 34px auto 120px;
    .project-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 41px;
      .project-item {
        width: 342.5px;
        height: 241px;
        border-radius: 10px;
        border: 0 solid #e5e7eb;
        background: #fff;
        box-shadow: -3px -7px 9.1px -4px rgba(0, 0, 0, 0.02),
          0 10px 15px -3px rgba(0, 0, 0, 0.06);
        margin-right: 34px;
        margin-bottom: 34px;
        cursor: pointer;
        position: relative;
        top: 0;
        transition: all 0.3s ease-in-out;
        .footer-row {
          display: flex;
          flex-direction: row;
          margin: 10px 16px 20px;
          height: 28px;
          line-height: 28px;
          .read-more {
            display: flex;
            flex-direction: row;
            .arrow-icon {
              width: 17px;
              height: 13px;
              margin: auto 0 auto 4px;
              object-fit: contain;
            }
            .text {
              color: #1b56a9;
              font-size: 14px;
              font-weight: bold;
            }
          }
          .name {
            flex: 1;
            color: #1f2937;
            font-size: 18px;
            font-weight: 600;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        .project-item-img {
          width: 100%;
          height: 183px;
          border-radius: 10px 10px 0 0;
          overflow: hidden;
          .image {
            width: 100%;
            height: 183px;
            object-fit: cover;
          }
        }
      }
      .project-item:hover {
        top: -10px;
      }
      .project-item:nth-child(4n + 4) {
        margin-right: 0;
      }
    }
    .tab-row {
      display: -webkit-box;
      flex-direction: row;
      height: 72px;
      border-bottom: 1px solid #e6e6e6;
      box-sizing: border-box;
      overflow-y: hidden;
      overflow-x: auto;
      .tab-flex {
        display: flex;
        flex-direction: column;
        margin-right: 44px;
        cursor: pointer;
        position: relative;
        .hr {
          max-width: 100%;
          width: 80px;
          height: 3px;
          background: #1b56a9;
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          bottom: -1px;
        }
        .item {
          color: #333;
          font-size: 20px;
          font-weight: 600;
          height: 60px;
          line-height: 60px;
        }

        .item-active {
          color: #1b56a9;
        }
      }
    }
    .icon-image {
      width: 362px;
      height: 64px;
      margin: 0 auto 34px;
      object-fit: cover;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .project-contain {
      width: 345px;
      margin: 28px auto 60px;
      .project-list {
        margin-top: 20px;
        .project-item {
          width: calc(100% / 2 - 5px);
          height: auto;
          margin-right: 10px;
          margin-bottom: 15px;
          .footer-row {
            height: 24px;
            line-height: 24px;
            margin: 8px 10px 10px;
            .read-more {
              .arrow-icon {
                width: 8.5px;
                height: 6.5px;
              }
              .text {
                font-size: 12px;
              }
            }
            .name {
              font-size: 13px;
            }
          }
          .project-item-img {
            height: 120px;
            .image {
              height: 120px;
              object-fit: cover;
            }
          }
        }
        .project-item:nth-child(2n + 2) {
          margin-right: 0;
        }
      }
      .tab-row {
        height: 45px;
        .tab-flex {
          margin-right: 30px;
          .hr {
            width: 40px;
            height: 2px;
          }
          .item {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
          }
        }
      }
      .icon-image {
        width: 250px;
        height: 38.4px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
